import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Spinner } from 'react-bootstrap';

import { getProductGroupBy } from '../../../controllers/product-service';
import { AsyncState } from '../../../utils/webRequests.type';
import './homeTrackedByRetailer.css';
import { selectCurrentOrgId } from '../../../reducers/profile/profileSlice';
import CardTable from '../CardTable/CardTable';
import ItemCountCard from '../ItemCountCard/ItemCountCard';
import sendRumError from '../../../utils/datadogRum';

/* eslint-disable react/no-array-index-key */
export default function HomeTrackedByRetailer() {
  const [dataLoadState, setDataLoadState] = useState<AsyncState>('uninitialized');
  const [retailerList, setRetailerList] = useState<string[][]>([]);
  const currentOrgId = useSelector(selectCurrentOrgId);

  useEffect(() => {
    setDataLoadState('loading');

    getProductGroupBy(
      Number(currentOrgId),
      'retailer',
    )
      .then((response) => {
        const retailerSorted = response.data.sort((a, b) => (b.count - a.count));
        const retailerData = retailerSorted.map(
          (row) => [
            row.selector,
            row.count.toLocaleString(),
          ],
        );
        setRetailerList(retailerData);
        setDataLoadState('completed');
      })
      .catch((error) => {
        sendRumError(error);
        setRetailerList([]);
        setDataLoadState('failed');
      });
  }, [currentOrgId]);

  return (
    <>
      {
        dataLoadState === 'loading' && (
          <Card>
            <Spinner animation="border" />
          </Card>
        )
      }
      {
        dataLoadState === 'failed' && (
          <Card
            data-testid="HomeTrackedByRetailer-DataLoadState-Failed"
          >
            <p>
              Something went wrong
              <br />
              while loading this resource.
            </p>
          </Card>
        )
      }
      {
        dataLoadState === 'completed' && retailerList.length > 1 && (
          <CardTable
            datatestid="HomeTrackedByRetailer-DataLoadState-Completed"
            title="Tracked by Retailer"
            columns={[
              'Retailer',
              'Item Count',
            ]}
            tableData={retailerList}
            className=""
          />
        )
      }
      {
        dataLoadState === 'completed' && retailerList.length === 1 && (
          <ItemCountCard
            datatestid="HomeTrackedByRetailer-DataLoadState-Completed"
            value={retailerList[0][1]}
            title={`Items at ${retailerList[0][0]}`}
            subTitle="100% of your portfolio"
          />
        )
      }
    </>
  );
}
